<template>
  <div class="c-payment-modal">
    <div class="message">
      <div class="message-container">
        <div class="text">
          <h3>Редактирование оплаты</h3>
          <p>Измените данные оплаты и сохраните изменения</p>
        </div>

        <div class="field">
          <div class="label">Дата начала</div>

          <c-calendar
            v-if="form.startAt"
            :date="form.startAt"
            @update:value="form.startAt = $event"
          />
        </div>

        <div class="field">
          <div class="label">Дата окончания</div>

          <c-calendar
            v-if="form.endAt"
            :date="form.endAt"
            @update:value="form.endAt = $event"
          />
        </div>

        <div class="field">
          <div class="label">Сумма</div>

          <n-input
            v-model="form.amount"
            type="number"
            placeholder="Введите сумму"
          />
        </div>

        <div class="buttons">
          <n-button
            flat
            class="modal-button cancel"
            @click="close"
          >
            Отмена
          </n-button>

          <n-button
            flat
            class="modal-button agree"
            :disabled="loading"
            @click="save"
          >
            {{ loading ? 'Сохранение...' : 'Сохранить' }}
          </n-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CCalendar from '../../components/calendar/Index.vue'

export default {
  name: 'CPaymentModal',

  components: {
    CCalendar,
  },

  props: {
    payment: {
      type: Object,
      default: () => ({}),
    },

    company: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,

      form: {
        startAt: null,
        endAt: null,
        amount: 0,
      },
    }
  },

  watch: {
    payment: {
      immediate: true,
      deep: true,
      handler(value) {
        this.fillForm(value)
      },
    },
  },

  methods: {
    parseDate(value) {
      if (!value) return null

      if (value instanceof Date) {
        return value
      }

      return new Date(String(value).replace(' ', 'T'))
    },

    fillForm(payment) {
      this.form = {
        startAt: this.parseDate(payment?.startAt),
        endAt: this.parseDate(payment?.endAt),
        amount: payment?.amount ?? 0,
      }
    },

    save() {
      if (this.loading) return

      this.loading = true
      this.$var('load', true)

      const data = {
        startAt: this.form.startAt,
        endAt: this.form.endAt,
        amount: Number(this.form.amount || 0),
      }

      $api.companies.updatePayment(this.payment.id, data)
        .then(() => {
          $app.notify?.success?.('Оплата обновлена')

          this.$emit('success')
          this.close()
        })
        .catch(() => {
          $app.notify?.error?.('Ошибка при сохранении')
        })
        .finally(() => {
          this.loading = false
          this.$var('load', false)
        })
    },

    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped lang="scss">
.c-payment-modal {
  position: fixed;
  inset: 0;
  z-index: 1020;

  background: rgba(0, 0, 0, 0.08);

  display: flex;
  align-items: center;
  justify-content: center;

  .message {
    background: #FFFFFF;
    border-radius: 18px;
    padding: 30px;

    min-width: 460px;
    max-width: 460px;
  }

  .message-container {
    width: 100%;
  }

  .text {
    margin-bottom: 24px;

    h3 {
      margin: 0 0 8px 0;
      font-size: 22px;
      font-weight: 700;
      color: var(--primary);
      text-align: center;
    }

    p {
      margin: 0;
      text-align: center;
      color: #7E7A9A;
      font-size: 15px;
      line-height: 22px;
    }
  }

  .field {
    margin-bottom: 18px;

    .label {
      margin-bottom: 10px;
      font-size: 14px;
      font-weight: 700;
      color: #2A2766;
    }
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 28px;

    :deep(.n-button) {
      border: none;
      border-radius: 12px;
      height: 46px;
      min-width: 130px;
      font-size: 15px;
      font-weight: 700;
    }

    .cancel {
      background: #FFFFFF !important;
      color: var(--primary) !important;
      border: 1px solid var(--primary) !important;
    }

    .agree {
      background: var(--primary) !important;
      color: #FFFFFF !important;
      box-shadow: 0 8px 20px rgba(42, 39, 102, 0.18);
    }
  }
}

@media (max-width: 600px) {
  .c-payment-modal {
    padding: 16px;

    .message {
      min-width: 100%;
      max-width: 100%;
      padding: 22px 18px;
    }

    .buttons {
      flex-direction: column;

      :deep(.n-button) {
        width: 100%;
      }
    }
  }
}
</style>
